module.exports = __webpack_public_path__ + "img/purpose_Image_two.2c5c2754.png";